export default (store) => {
	store.subscribe(async (mutation) => {
		// Run rules and commit workflowsteps
		if (mutation.type === 'workflow/setToggleEnabledState' || mutation.type === 'workflow/setWfStep') {
			const workflowSteps = await store.dispatch('wfRules/runRules');
			store.commit('workflow/setWfSteps', workflowSteps, {root: true});
		}
	});
};
